<div class="flex flex-col gap-3 p-4">
  <div class="flex items-center justify-between">
    <h1 class="text-primary text-2xl font-bold" i18n="@@attributesManagement">Attributes Management</h1>
    <a
      routerLink="add-attribute"
      class="add-button flex items-center justify-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
      <span i18n="@@addAttribute">Add Attribute</span>
    </a>
  </div>

  <div class="mb-4 rounded-2xl bg-white p-4 shadow-md">
    <div class="mt-4 overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
      <table class="w-full text-left">
        <thead class="bg-gray-50 text-[13px] text-gray-500 uppercase">
          <tr>
            <th class="w-px py-4 ps-4 pe-6 whitespace-nowrap">#</th>
            <th class="px-6 py-4" i18n="@@tableTitle">Title</th>
            <th class="px-6 py-4" i18n="@@tableValues">Values</th>
            <th class="w-px py-4 ps-6 pe-4 text-center"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          @for (attr of attributesList(); track attr; let attrIdx = $index) {
            <tr class="transition-colors hover:bg-gray-50">
              <td class="py-4 ps-4 pe-6 font-medium text-gray-400">{{ attrIdx + 1 }}.</td>
              <td class="px-6 py-4 font-bold text-gray-700">{{ attr.attributeKey.titleEn }}</td>
              <td class="px-6 py-4">
                <div class="flex flex-wrap items-center gap-2">
                  @for (val of attr.attributeValues; track val; let valIdx = $index) {
                    <span
                      class="flex items-center gap-2 rounded-full border border-purple-100 bg-purple-50 px-3 py-1 text-[12px] font-bold text-purple-600">
                      {{ val.titleEn }}
                      <div class="ml-1 flex items-center gap-2 border-l border-purple-200 pl-2">
                        <button
                          (click)="openEditValueModal($event, attrIdx, valIdx)"
                          class="cursor-pointer text-purple-400 transition-colors hover:text-blue-600">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round">
                            <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                          </svg>
                        </button>
                        <button
                          (click)="deleteAttributeValue(attrIdx, valIdx); $event.stopPropagation()"
                          class="cursor-pointer text-purple-400 transition-colors hover:text-red-600">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                      </div>
                    </span>
                  }
                </div>
              </td>
              <td class="w-px py-4 ps-6 pe-4 text-center">
                <div class="flex justify-center gap-4">
                  <button
                    (click)="editAttribute(attr)"
                    class="cursor-pointer text-blue-400 transition-colors hover:text-blue-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                  </button>
                  <button
                    (click)="removeAttFromTable(attrIdx)"
                    class="cursor-pointer transition-colors hover:text-red-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

@if (isModalOpen()) {
  <app-add-new-value
    [editData]="editData()"
    (onSave)="handleValueAdded($event)"
    (onClose)="isModalOpen.set(false)"></app-add-new-value>
}
